/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

Blockly.Blocks.blue_read = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ADVANCED_BLUE_READ);
    // Sin check, igual que serial_read: el codebase mezcla string y constructor para String y un
    // check fijo rompe las conexiones de un lado.
    this.setOutput(true);
  },
};

Blockly.Blocks.bluetooth_name = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendValueInput('DATOIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_BLUETOOTH_NAME);
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_BLUETOOTH_NAME_TOOLTIP);
  },
};

Blockly.Blocks.bt_serial_available = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_ADVANCED_BT_SERIAL_AVAILABLE);
    this.appendStatementInput('DO')
      .appendField(Blockly.Msg.LANG_CONTROLS_REPEAT_INPUT_DO);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_ADVANCED_BT_SERIAL_AVAILABLE_TOOLTIP);
  },
};
